export default "__VITE_ASSET__CqlRq0np__"